var React = require('react');

function Columns (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27 29a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h22Zm-16-2V5H5v22h6Zm8-22h-6v22h6V5Zm2 22h6V5h-6v22Z"}));
}

Columns.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = Columns;

Columns.default = Columns;
